import {ScanCustomerDTO} from "./scanCustomerDTO.interface";
import {BaseCustomerDTO} from "../baseCustomerDTO.interface";

export interface RemarqCustomerDTO extends BaseCustomerDTO {
  scanCustomer: ScanCustomerDTO;
}
